import React from 'react'

import { Select, SelectProps } from '../../../components/forms/select/select.js'
import { GridColumn } from '../../../components/grid/grid-column.js'
import { Grid } from '../../../components/grid/grid.js'

export interface DebugProps {
    title: string
    subscriptionSelect?: SelectProps
}

export const Debug = (props: DebugProps): JSX.Element => {
    return (
        <div className="text">
            <Grid className="text__margin-double login__options" justify={['center-xs']}>
                <GridColumn width={['md-10', 'lg-5']}>
                    <div className="text">
                        <h3>{props.title}</h3>
                        {props.subscriptionSelect && <Select {...props.subscriptionSelect} bordered={true} />}
                    </div>
                </GridColumn>
            </Grid>
        </div>
    )
}
